export const HISTORY_TRAITS = [
  {key: 'pupilsPremium', label: 'PP', name: 'Pupil Premium'},
  {key: 'specialEducationNeeds', label: 'SEN', name: 'Special Educational Needs'},
  {key: 'freeSchoolMeals', label: 'FSM', name: 'Free School Meals'},
  {key: 'ethnicityCode', label: 'Ethnicity', name: 'Ethnicity code'}
] as const;
export type HistoryTraitField = typeof HISTORY_TRAITS[number]['key'];
export function historyCsv(rows: any[], fields: readonly string[]) {
  const columns = ['studentId', 'permissionId', 'firstName', 'lastName', 'from', 'to', 'groupKey', 'groupLabel', 'formId', 'houseId', ...fields];
  const quote = value => `"${String(value == null ? '' : value).replace(/^[=+@-]/, "'$&").replace(/"/g, '""')}"`;
  return [columns.join(','), ...rows.map(row => columns.map(column => quote(row[column])).join(','))].join('\r\n');
}
